module.exports = __webpack_public_path__ + "static/media/start_business_01.83d4668d.png";